/* eslint-disable @typescript-eslint/no-explicit-any */
export const calculateTotalSalesSummary = (data: any[], nameOverride: string): any => {
  const totals = data.reduce((acc, curr) => {
    return {
      hosyuCnt: (acc.hosyuCnt || 0) + (curr.hosyuCnt || 0),
      jishinDousaCnt: (acc.jishinDousaCnt || 0) + (curr.jishinDousaCnt || 0),
      jishinkeiCnt: (acc.jishinkeiCnt || 0) + (curr.jishinkeiCnt || 0),
      jidouTaisyouCnt: (acc.jidouTaisyouCnt || 0) + (curr.jidouTaisyouCnt || 0),
      herSumiCnt: (acc.herSumiCnt || 0) + (curr.herSumiCnt || 0),
      sssippaiCnt: (acc.sssippaiCnt || 0) + (curr.sssippaiCnt || 0),
      jishinHappouTaisyouCnt:
        (acc.jishinHappouTaisyouCnt || 0) + (curr.jishinHappouTaisyouCnt || 0),
      taishougaiCnt: (acc.taishougaiCnt || 0) + (curr.taishougaiCnt || 0),
      taishougaiKakuninCnt: (acc.taishougaiKakuninCnt || 0) + (curr.taishougaiKakuninCnt || 0),
      happouTeishiCnt: (acc.happouTeishiCnt || 0) + (curr.happouTeishiCnt || 0),
      teishiDaisu2: (acc.teishiDaisu2 || 0) + (curr.teishiDaisu2 || 0),
      teishiDaisu1: (acc.teishiDaisu1 || 0) + (curr.teishiDaisu1 || 0),
      totalTojikomeCnt: (acc.totalTojikomeCnt || 0) + (curr.totalTojikomeCnt || 0),
      tojikomeKyuushustuCnt: (acc.tojikomeKyuushustuCnt || 0) + (curr.tojikomeKyuushustuCnt || 0),
      teishiDaisu: (acc.teishiDaisu || 0) + (curr.teishiDaisu || 0),
      fukkyuDaisu: (acc.fukkyuDaisu || 0) + (curr.fukkyuDaisu || 0),
      hdKariFukkyuuCnt: (acc.hdKariFukkyuuCnt || 0) + (curr.hdKariFukkyuuCnt || 0),
      hdHonFukkyuuCnt: (acc.hdHonFukkyuuCnt || 0) + (curr.hdHonFukkyuuCnt || 0),
      teishiCnt: (acc.teishiCnt || 0) + (curr.teishiCnt || 0),
      bussonCnt: (acc.bussonCnt || 0) + (curr.bussonCnt || 0),
      teidenCnt: (acc.teidenCnt || 0) + (curr.teidenCnt || 0),
      oncallTaiouDaisu: (acc.oncallTaiouDaisu || 0) + (curr.oncallTaiouDaisu || 0),
      yousyoriCnt: (acc.yousyoriCnt || 0) + (curr.yousyoriCnt || 0),
      grTeishiYosokuCnt: (acc.grTeishiYosokuCnt || 0) + (curr.grTeishiYosokuCnt || 0),
    };
  }, {} as any);

  totals.tojikomeKyuushustuRate =
    totals.totalTojikomeCnt > 0
      ? (totals.tojikomeKyuushustuCnt / totals.totalTojikomeCnt) * 100
      : 0;
  totals.fukkyuRate = totals.teishiCnt > 0 ? (totals.fukkyuDaisu / totals.teishiCnt) * 100 : 0;
  totals.hdHonFukkyuuRate =
    totals.hdKariFukkyuuCnt > 0 ? (totals.hdHonFukkyuuCnt / totals.hdKariFukkyuuCnt) * 100 : 0;

  totals.salesOfficeName = nameOverride;
  totals.sectionCode = '';

  return totals;
};
